import React from "react";
import style from "./style.module.css";

const CrtAccessBanner = () => (
    <div className={style.banner} role="status">
        <div className={style.content}>
            <span className={style.icon} aria-hidden="true">i</span>
            <p className={style.text}>
                Сайт может перестать открываться — узнайте,{" "}
                <a
                    href="https://www.gosuslugi.ru/landing/crt"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={style.link}
                >
                    как сохранить к нему доступ
                </a>
            </p>
        </div>
    </div>
);

export default CrtAccessBanner;
